import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ImageInterface } from 'src/app/types/image';

interface ImageCardInterface {
  items: ImageCardItem;
  template: string;
}

interface ImageCardItem {
  button_link: string;
  button_target: string;
  button_text: string;
  description: string;
  img: ImageInterface;
  placement: string;
  sub_title: string;
  title: string;
}

@Component({
  selector: 'app-image-card',
  templateUrl: './image-card.component.html',
  styleUrls: ['./image-card.component.scss'],
  host: { class: 'ion-content-stretched' },
})
export class ImageCardComponent implements OnInit {
  columnCount: number;

  @Input() node: ImageCardInterface;

  constructor(private router: Router) {}

  buttonLink() {
    const buttonLink = this.node.items[0].button_link;

    if (buttonLink.indexOf('//') < 0) {
      if (
        typeof window !== 'undefined' &&
        this.node?.items[0].button_target === '_blank'
      ) {
        window?.open(buttonLink, this.node?.items[0].button_target);
      } else {
        this.router.navigate([buttonLink]);
      }
    } else if (typeof window !== 'undefined') {
      window?.open(buttonLink, this.node?.items[0].button_target);
    }
  }

  ngOnInit() {
    if (this.node?.template)
      this.columnCount = 12 / parseInt(this.node.template.replace('grid-', ''));
  }
}
